import type { SurgeryData } from "@qendo/medical/surgery";
import { MedicalType } from "@qendo/medical/types";
import type { DateArg } from "date-fns";
import Data from "~/util/data";

export class Surgery extends Data implements SurgeryData {
    public readonly type = MedicalType.surgery;

    public constructor(
        public id?: string,
        public description: string | null = null,
        public option_id: string | null = null,
        public photograph_ids: string[] = [],
        public procedure_date: string | DateArg<Date> | null = null,
    ) {
        super();
    }
}
